import React, { useCallback } from 'react';
import { observer } from 'mobx-react';

import { Network } from 'react-fns';
import { BrowserRouter } from 'react-router-dom';
import { useIntl } from 'react-intl';

import BasePage from './components/BasePage/BasePage';
import BaseHeader from './components/BasePage/Header';
import BaseContent from './components/BasePage/LargeContent';
import Header from './components/Header/Header';
import LandscapeWarning from './components/LandscapeWarning/LandscapeWarning';
import OfflineWarning from './components/OfflineWarning/OfflineWarning';
import AppRoute from './AppRoute';
import messages from './messages';
import { useStores } from './store/useStores';
import { useEventListener } from './utils/useEventListener';
import { LastLocationProvider } from './store/lastLocation';
import { RouterSync } from './store/RouterSync';

function App() {
  const intl = useIntl();
  const { authStore, uiState, fileUploadStore } = useStores();
  const { isLoggedIn } = authStore;

  const handleLeavePage = useCallback(
    e => {
      if (!fileUploadStore.canDrop) {
        const confirmationMessage =
          'Er zijn nog files bezig aan het opladen. Deze files gaan verloren indien je de pagina afsluit.';
        e.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    },
    [fileUploadStore.canDrop]
  );

  useEventListener(() => window, 'beforeunload', handleLeavePage);

  return (
    <BrowserRouter>
      <RouterSync />
      <LastLocationProvider>
        <BasePage fullheight>
          <BaseHeader isLoggedIn={isLoggedIn}>
            <Header menuClick={() => uiState.toggleMenu()} />
          </BaseHeader>
          <BaseContent>
            <AppRoute />
          </BaseContent>
          <LandscapeWarning
            title={intl.formatMessage(messages.landscapeWarningTitle)}
            message={intl.formatMessage(messages.landscapeWarningDescription)}
          />
          <Network
            render={({ online }) => (
              <div>
                {online ? null : (
                  <OfflineWarning
                    title={intl.formatMessage(messages.offlineWarningTitle)}
                    message={intl.formatMessage(
                      messages.offlineWarningDescription
                    )}
                  />
                )}
              </div>
            )}
          />
        </BasePage>
      </LastLocationProvider>
    </BrowserRouter>
  );
}

export default observer(App);
